<template>
    <div id="received-files-sidebar" class="h-100 bg-light shadow">
        <div class="d-flex flex-column">
            <received-files-sidebar-section v-for="section in sections" :key="section.id" :section="section"></received-files-sidebar-section>
        </div>
    </div>
</template>
<script>
import ReceivedFilesSidebarSection from './received-files-sidebar-section'

export default {
    components: {
        ReceivedFilesSidebarSection
    },
    data: function() {
        return {
            sections: [
                {
                    id: 1,
                    title: "All Files",
                    entries: [
                        {
                            id: 0,
                            name: "Inbox",
                            count: 254,
                            unreadCount: 132,
                            icon: "inbox-in"
                        },
                        {
                            id: 1,
                            name: "Archive",
                            count: 165,
                            unreadCount: 0,
                            icon: "archive"
                        },
                        {
                            id: 2,
                            name: "Deleted",
                            count: 25,
                            unreadCount: 0,
                            icon: "trash-alt"
                        }
                    ]
                },
                {
                    id: 2,
                    title: 'Folders',
                    entries:[
                        {
                            id: 11,
                            name: "Project One",
                            count: 72,
                            unreadCount: 24,
                            icon: "folder-download"
                        },
                        {
                            id: 12,
                            name: "Personal",
                            count: 3,
                            unreadCount: 1,
                            icon: "folder-download"
                        },
                        {
                            id: 13,
                            name: "Accounts",
                            count: 147,
                            unreadCount: 35,
                            icon: "folder-download"
                        }
                    ]
                }
            ]
        }
    }
}
</script>
<style scoped>
    #received-files-sidebar {
        min-width: 250px;
        border-right: #e9ecef solid 1px;
        z-index: 6;
    }

    .bg-light-dark {
        background-color: #dee2e6;
    }
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-sidebar.vue